import BlockHeader, { BlockHeaderProps } from './BlockHeader';

export type { BlockHeaderProps };
export default BlockHeader;
